// src/lib/patent.js
// Który patent zdaje gracz - jedno miejsce dla całej gry.
//
// Rejs (ekran /intro i /quiz) nie ma parametru w adresie, bo trasa musi zostać
// taka sama jak w reszcie rodziny serwisów. Wybór trzymamy więc w localStorage:
// gracz ustawia go raz na /start, a każdy kolejny pojedynek losuje pytania
// z właściwej puli. Klucz jest prefiksowany nazwą serwisu, żeby nie kolidował
// z niczym innym w tej samej domenie.

import { PATENTY } from '../data/patenty';

const KLUCZ = 'zeglarka_patent';

export const PATENT_DOMYSLNY = 'zeglarz-jachtowy';

export const SLUGI = PATENTY.map(p => p.slug);

/** Slug wybranego patentu; przy braku lub śmieciach w pamięci - żeglarz jachtowy. */
export const wybranyPatent = () => {
  if (typeof window === 'undefined') return PATENT_DOMYSLNY;
  try {
    const zapisany = window.localStorage.getItem(KLUCZ);
    return SLUGI.includes(zapisany) ? zapisany : PATENT_DOMYSLNY;
  } catch (e) {
    return PATENT_DOMYSLNY;
  }
};

export const zapiszPatent = slug => {
  if (typeof window === 'undefined' || !SLUGI.includes(slug)) return;
  try {
    window.localStorage.setItem(KLUCZ, slug);
  } catch (e) {
    /* tryb prywatny - trudno, zostaje domyślny patent */
  }
};

/** Pełny opis wybranego patentu (nazwa, dopełniacz, uprawnienia). */
export const opisPatentu = (slug = wybranyPatent()) =>
  PATENTY.find(p => p.slug === slug) || PATENTY[0];
